import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import React from "react";
import { StyledCard } from "./card.style";

const Card = ({ title, icon, link }) => {
    return (
        <StyledCard>
            <Link to={link}>
                <p>{title}</p>
                {icon && icon.childImageSharp && (
                    <GatsbyImage image={icon.childImageSharp.gatsbyImageData} alt="Banner" />
                )}
            </Link>
        </StyledCard>
    );
};

Card.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    link: PropTypes.string,
};

export default Card;
